// removed by extract-text-webpack-plugin
module.exports = {"filter":"styles-module__filter___1w_4F","container":"styles-module__container___2Lgin"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/LeftPanel/Settings/FilterSettings/styles.module.css
// module id = 468
// module chunks = 0